<template>
  <span id="post-list-title">
    <span v-html="getTitleChannel() + getTitlePage()" class="title"></span>
    <span v-html="getCountPage()" class="count"></span>
    <template v-if="isChannelSite()">
      /
      <template v-if="getPageNotes()">
        <span v-html="getTitlePosts()" class="title2" @click="onPosts()"></span> / <span class="title2" @click="onPromocode()">Промокоды</span> / <span v-html="getTitleArticles()" class="title2" @click="onArticles()"></span>
      </template>
          <template v-else-if="getPageNotesNotModerated()">
        <span class="title2" @click="onPosts()">Посты</span> / <span class="title2" @click="onPromocode()">Промокоды</span> / <span v-html="getTitleNotes()" class="title2" @click="onNotes()"></span> / <span v-html="getTitleArticles()" class="title2" @click="onArticles()"></span>
      </template>
      <template v-else-if="getPagePromocode()">
        <span class="title2" @click="onPosts()">Посты</span> / <span v-html="getTitleNotes()" class="title2" @click="onNotes()"></span> / <span v-html="getTitleArticles()" class="title2" @click="onArticles()"></span>
      </template>
      <template v-else-if="getPagePosts()">
        <span class="title2" @click="onPromocode()">Промокоды</span> / <span v-html="getTitleNotes()" class="title2" @click="onNotes()"></span> / <span v-html="getTitleArticles()" class="title2" @click="onArticles()"></span>
      </template>
      <template v-else-if="getPageArticles()">
        <span class="title2" @click="onPosts()">Посты</span> / <span class="title2" @click="onPromocode()">Промокоды</span> / <span v-html="getTitleNotes()" class="title2" @click="onNotes()"></span>
      </template>
    </template>
  </span>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, ref, watch} from "vue"
import Image from "@/services/Image"
import {getChannels} from "@/modules/post/plugins/title/services/channels"
import {useRouter} from "vue-router/dist/vue-router"

export default defineComponent({
  name: "Title",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter()

    let titleChannel = ref("")
    let channels = ref(null)
    let countPosts = ref(0)

    watch(() => getChannels(), (val) => {
      setChannels(val)
      renderTitle()
    })

    watch(() => props.data['count_posts'], (val) => {
      setCountPosts(val)
    })

    onMounted(() => {
      setChannels(getChannels())
      renderTitle()
      setCountPosts(props.data['count_posts'])
    })

    function setCountPosts(val) {
      countPosts.value = val
    }

    function setChannels(val) {
      channels.value = val
    }

    function renderTitle() {
      loadTitleChannel(props.data['channel_id'])
    }

    function loadTitleChannel(channelId) {
      if (channels.value === null) {
        return false
      }

      let result = channels.value[channelId]

      if (result["image_host"] === null || result["image_name"] === null) {
        throw Error("Отсутствует иконка")
      }

      let src = Image.handle(result["image_host"], result["image_name"], 60, 60);

      let href = router.resolve({
        name: 'Posts',
        params: {
          channel_id: channelId,
        },
      }).href

      let img = `<img width="30" class="rounded" src="${src}" alt="">`
      let link = `<a href="${href}">${result["title"]}</a>`

      titleChannel.value = img + " " + link
    }

    function getTitleChannel() {
      let result = ""

      if (titleChannel.value) {
        result += titleChannel.value + " - "
      }

      return result
    }

    function getTitlePage() {
      return props.data['title_page']
    }

    function getCountPage() {
      let result = ""

      if (countPosts.value > 0) {
        result += ": <span>" + countPosts.value + "</span>"
      }

      return result
    }

    function getTitleNotes() {
      return "Заметки"
    }

    function getTitlePosts() {
      return "Посты"
    }

    function getTitleArticles() {
      return "Статьи"
    }

    function getPageNotes() {
      return props.data['page'] === "notes" || props.data['page'] === "notes_drafts"
    }

    function getPagePromocode() {
      return props.data['page'] === "promocode" || props.data['page'] === "promocode_drafts"
    }

    function getPagePosts() {
      return props.data['page'] === "posts" || props.data['page'] === "posts_drafts"
    }

    function getPageArticles() {
      return props.data['page'] === "articles" || props.data['page'] === "articles_drafts"
    }

    function getPageNotesNotModerated() {
      return props.data['page'] === "notes" || props.data['page'] === "notes_not_moderated"
    }



    function onNotes() {
      return router.push({name: "Notes"})
    }

    function onPosts() {
      return router.push({name: "Posts", params: { channel_id: props.data['channel_id'] }})
    }

    function onPromocode() {
      return router.push({name: "Promocode"})
    }

    function onArticles() {
      return router.push({name: "PostArticles"})
    }

    function isChannelSite() {
      return props.data['channel_id'] === 1
    }

    return {
      getTitleChannel,
      getTitlePage,
      getCountPage,
      getTitleNotes,
      getTitlePosts,
      getTitleArticles,
      getPageNotes,
      getPageNotesNotModerated,
      getPagePromocode,
      getPageArticles,
      getPagePosts,
      onNotes,
      onPosts,
      onPromocode,
      onArticles,
      isChannelSite,
    }
  },
})
</script>
